import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { DepartmentsFilterOption } from '../models/department-filter-option';
import { DepartmentRegisterListItem } from '../models/department-register-results.model';

const area = 'Department Register';

export const departmentRegisterAdapterActions = createRegisterActions<DepartmentRegisterListItem>(area);

export const departmentRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: DepartmentsFilterOption[] }>()
);

export const loadDepartmentSuccess = createAction(`[${area}] Load Department Success`);

export const loadDepartmentFailure = createAction(`[${area}] Load Department Failure`);

export const createDepartment = createAction(`[${area}] Create Department`);

export const setSelectedDepartmentId = createAction(`[${area}] Set Selected ID`, props<{ departmentId: number }>());

export const refreshList = createAction(`[${area}] Refresh List`);

export const loadingUrlParams = createAction(`[${area}] Loading URL Params`);

export const loadedUrlParams = createAction(`[${area}] Loaded URL Params`, props<{ departmentId: number | null }>());

export const loadDepartmentNamesSuccess = createAction(
   `[${area}] Load Department Names Success`,
   props<{ departmentNames: string[] }>()
);
